import Vue from 'vue';
import {noticeUnreadCount} from '../../api/api';

// 创建响应式对象
export const notificationState = Vue.observable({
  unreadCount: 0
})

// 更新方法
export const fetchUnreadCount = () => {
    //企业显示未读通知数目
    notificationState.unreadCount=0
    var user = sessionStorage.getItem('user');
    if (user) {
        user = JSON.parse(user);
        if(user.data.roleId =='4'){
            let para = {
                coId: user.data.coId,
            };

            noticeUnreadCount(para).then((res) => {
                // console.log(res.data)
                if(res.data.code==0){
                    notificationState.unreadCount= res.data.data;
                }
            });
        }
    }
    
}

// 使用方法
// 显示页面
// <span v-if="unreadCount!=0" style="margin-right: 10px;color: white;">未读通知<el-badge :max="99"  :value="unreadCount" /></span>
// import { notificationState, fetchUnreadCount  } from '../common/js/notificationState';
// computed: {
//     unreadCount() {
//     return notificationState.unreadCount // 响应式获取
//     }
// },
// mounted() {
//     fetchUnreadCount() //读取
// }
// 其他页面
// import {fetchUnreadCount  } from '../../common/js/notificationState';
//fetchUnreadCount() //未读通知数


// WEBPACK FOOTER //
// ./src/common/js/notificationState.js